// extracted by mini-css-extract-plugin
export default {"colorControls":"BadgeFormModal_colorControls__Z-olu","backgroundColorControl":"BadgeFormModal_backgroundColorControl__-h33z","preview":"BadgeFormModal_preview__uHgYn"};